import React from "react";

export default class CheckboxFilter extends React.Component {
    constructor(props) {
        super(props);
        this.filter = this.filter.bind(this);
        this.isFiltered = this.isFiltered.bind(this);
    }

    filter(event) {
        if (this.refs.nokCheckbox.checked && this.refs.okCheckbox.checked) {
            this.props.filterHandler();
        } else {
            this.props.filterHandler({callback: this.isFiltered});
        }
    }

    isFiltered(targetValue) {
        if (targetValue === true) {
            return (this.refs.okCheckbox.checked);
        } else {
            return (this.refs.nokCheckbox.checked);
        }
    }

    render() {
        return (
            <div style={{marginTop: 1,fontSize:'12px'}}>
                <div>
                <input ref='okCheckbox' type='checkbox' className='filter' onChange={this.filter}
                       defaultChecked={true}/><label>{' '}{this.props.textOK}</label>
                </div>
                <div>
                <input ref='nokCheckbox' type='checkbox' className='filter' onChange={this.filter} defaultChecked={true}
                       style={{}}/><label>{' '}{this.props.textNOK}</label>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/zarzadzanie/filters/CheckboxFilter.js